<script setup>
import { ref } from 'vue';
import {
  MapPin, Mail, Phone, ChevronRight,
  Facebook, Twitter, Instagram, Linkedin, Youtube
} from 'lucide-vue-next';

const email = ref('');

const subscribeNewsletter = () => {
  if (email.value) {
    console.log('Subscribing email:', email.value);
    email.value = '';
  }
};
import { useThemeStore } from '../../stores/themeStore';
import footer from '@/dashbaord/Pages/footer.vue'

// Footer data inside the same file


// Map string icon names to imported icon components
const socialIconsMap = { Facebook, Twitter, Instagram, Linkedin, Youtube };
// const socialLinks = footerData.socialLinks.map(link => ({
//   ...link,
//   icon: socialIconsMap[link.icon]
// }));
const themeStore = useThemeStore();
</script>

<template>
  <footer class="bg-gray-900 text-gray-300 py-12 px-6 lg:px-16">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
      
      <!-- Logo and Description -->
      <div>
        <span class="text-2xl font-bold text-white">
          {{ themeStore.theme.footerData.siteName.replace(themeStore.theme.footerData.siteHighlight, '') }}
          <span :style="{ color: themeStore.theme.footerData.highlightColor }">
            {{ themeStore.theme.footerData.siteHighlight }}
          </span>
        </span>
        <p class="text-sm mt-4 leading-relaxed">{{ themeStore.theme.footerData.description }}</p>

        <div class="mt-6 space-y-4 text-sm">
          <div class="flex items-center gap-3">
            <MapPin class="w-4 h-4" /> {{ themeStore.theme.footerData.address }}
          </div>
          <div class="flex items-center gap-3">
            <Mail class="w-4 h-4" /> <a :href="'mailto:' + themeStore.theme.footerData.email">{{ themeStore.theme.footerData.email }}</a>
          </div>
          <div class="flex items-center gap-3">
            <Phone class="w-4 h-4" /> <a :href="'tel:' + themeStore.theme.footerData.phone">{{ themeStore.theme.footerData.phone }}</a>
          </div>
        </div>
      </div>

      <!-- Useful Links -->
      <div>
        <h3 class="text-lg font-semibold text-white mb-4">Useful Links</h3>
        <ul class="space-y-3">
          <li v-for="link in themeStore.theme.footerData.usefulLinks" :key="link.name" class="flex items-center gap-2 hover:text-white">
            <ChevronRight class="w-4 h-4" /> <a :href="link.href">{{ link.name }}</a>
          </li>
        </ul>
      </div>

      <!-- Recent Posts -->
      <div>
        <h3 class="text-lg font-semibold text-white mb-4">Recent Posts</h3>
        <div v-for="post in themeStore.theme.footerData.recentPosts" :key="post.title" class="flex items-center gap-4 mb-4">
          <img :src="post.image" alt="Post" class="w-16 h-16 rounded object-cover" />
          <div>
            <p class="text-sm">{{ post.title }}</p>
            <span class="text-xs text-gray-400">{{ post.date }}</span>
          </div>
        </div>
      </div>

      <!-- Newsletter -->
      <div>
        <h3 class="text-lg font-semibold text-white mb-4">Newsletter</h3>
        <p class="text-sm mb-4">Subscribe to our newsletter to get our latest updates.</p>
        <div class="flex items-center">
          <input v-model="email" type="email" placeholder="Your email" class="w-full px-3 py-2 rounded-l bg-gray-800 text-white outline-none" />
          <button @click="subscribeNewsletter" class="bg-yellow-500 px-4 py-2 rounded-r text-black font-semibold">Send</button>
        </div>

        <!-- Social Icons -->
        <div class="flex gap-4 mt-6">
          <a v-for="social in themeStore.theme.footerData.socialLinks" :key="social.name" :href="social.href" target="_blank" rel="noopener noreferrer">
            <component :is="social.icon" class="w-5 h-5 hover:text-yellow-500" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
